import { EventBus } from '../../../plugins/eventBus';

class CommonHandlerResTool {
  successCode = 'SUCCESS';

  // post请求
  $PostRequest(param) {
    param.load.showLoadding();
    // this.$axios.post(param.url, param.formData, param.config).then((response) => {
    param.$axios.post(param.url, param.formData, param.config).then((response) => {
      this.responseHandler(response);
    });
  }

  // get请求
  $GetRequest(param) {
    // 看业务需求再补充方法
    param.load.showLoadding();
    // this.$axios.get(param.url).then((response) => {
    param.$axios.get(param.url).then((response) => {
      this.responseHandler(response, param);
    });
  }

  responseHandler(response, param) {
    console.log(response);
    param.load.hideLoadding();
    if (response.status === 200) {
      // 成功后的操作
      if (response.data.errorCode === this.successCode) {
        const fun = param.callFun;
        fun !== undefined && param.callFun(response);
        if (!param.tipFlag) {
          EventBus.$emit('toast', { type: 'success', content: '操作成功' });
        }
      } else {
        EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
      }
    } else {
      EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
    }
  }
}

export default CommonHandlerResTool;
